
import { Component, OnInit} from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators
} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {UserService} from '../../services/user.service';
import {PasswordValidation, regExps} from './password-validation';
import {ViewChild} from '@angular/core';
import {MessageComponent} from '../messages/message.component';
import { AuthGuardService } from '../../services/auth-guard.service';

@Component({
  selector: 'register-form',
  templateUrl: './register-form.component.html',
  styleUrls: ['./register-form.scss']
})
export class RegisterFormComponent implements OnInit {
  registerForm: FormGroup;
  email: FormControl;
  password: FormControl;
  repassword: FormControl;
  firstName: FormControl;
  lastName: FormControl;
  attempts: Number;
  message: String;
  typeStyle: String;
  openedPopUp: boolean;
  @ViewChild(MessageComponent) public messageComponent: MessageComponent;


  public constructor(
      private http: HttpClient, private router: Router,
      private UserService: UserService, private auth: AuthGuardService) {
    this.openedPopUp = false;
  }

  ngOnInit() {
    this.createFormControls();
    this.createForm();
  }


  uppercase(control: FormControl) {
    if (control.value.length == 0) return {
        uppercase: {message: "At least one uppercase letter"}
      }
    if (!regExps.uppercase.test(control.value)) {
      return { uppercase: {message: "At least one uppercase letter"} }
    }
    return null;
  }

  lowercase(control: FormControl) {
    if (control.value.length == 0) return {
        lowercase: {message: "At least one lowercase letter"}
      }
    if (!regExps.lowercase.test(control.value)) {
      return { lowercase: {message: "At least one lowercase letter"} }
    }
    return null;
  }

  number(control: FormControl) {
    if (control.value.length == 0) return {
        number: {message: "At least one number"}
      }
    if (!regExps.number.test(control.value)) {
      return { number: {message: "At least one number"} }
    }
    return null;
  }

  symbol(control: FormControl) {
    if (control.value.length == 0) return {
        symbol: {message: "At least one symbol"}
      }
    if (!regExps.symbol.test(control.value)) {
      return { symbol: {message: "At least one symbol"} }
    }
    return null;
  }

  minlength(control: FormControl) {
    if (control.value.length <= 7)
      return {minlength: {message: "At least 8 characters"}};
    return null;
  }

  popUp() { this.openedPopUp = !this.openedPopUp; }

  createFormControls() {
    this.email = new FormControl(
        '', [Validators.required, Validators.pattern("[^ @]*@[^ @]*")]);
    this.password = new FormControl('', [
      Validators.required, this.minlength, this.uppercase, this.lowercase,
      this.number, this.symbol
    ]);
    this.repassword =
        new FormControl('', [Validators.required, Validators.minLength(8)]);
    this.firstName = new FormControl('', [Validators.required]);
    this.lastName = new FormControl('', [Validators.required]);
  }

  createForm() {
    this.registerForm = new FormGroup(
        {
          email: this.email,
          password: this.password,
          repassword: this.repassword,
          firstName: this.firstName,
          lastName: this.lastName
        },
        {validators: PasswordValidation.MatchPassword});
  }


  onSubmit() {
    if (this.registerForm.valid) {
      const email = this.email.value.toLowerCase();
      const pass = this.password.value;
      const userProfile = {
        username: email,
        password: pass,
        name: this.firstName.value,
        lastName: this.lastName.value
      };

      this.UserService.register(userProfile)
          .subscribe(
              res => {
                this.messageComponent.showSuccess(
                    "User have been registred properly, an email has been sent to activate your account!");
                
                this.auth.login(email, pass)
                    .subscribe(
                        data => { 
                          this.router.navigate(['home']);
                          setTimeout(() => {window.location.reload();}, 500);
                        },
                        err => {
                          if (err && err.error && err.error.errors &&
                              err.error.errors.length > 0) {
                            if (err.error.errors[0].attemps) {
                              this.attempts = err.error.errors[0].attemps;
                            }
                            this.messageComponent.showError(
                                err.error.errors[0].message);
                          } else {
                            this.messageComponent.showError(err);                            
                          }
                        });
              },
              err => {
                if (err && err.error && err.error.errors &&
                    err.error.errors.length > 0)
                  this.messageComponent.showError(err.error.errors[0].message);
                else
                  this.messageComponent.showError(err);
              });
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/components/register-form/register-form.component.ts